const RefundByRefrenceResponse = {
	"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"refundEticketNumbers": [
		{
			"eTicketNumber": "string",
			"eticketStatus": 0,
			"isRefunded": "string",
			"airlinePnr": "string",
			"penaltyAmount": 0
		}
	]
};


export default RefundByRefrenceResponse;
